module.exports = __webpack_public_path__ + "static/media/enter_full_screen.bbc6d48b.svg";